
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.573 21.48a2.603 2.603 0 00-1.913-.847h-.775a.815.815 0 01-.63-.29.804.804 0 01-.217-.654c.048-.436.436-.751.896-.751h.896c.242 0 .484.17.532.436.024.17.194.266.34.266h1.016a.389.389 0 00.266-.12.364.364 0 00.097-.267 2.218 2.218 0 00-1.96-2.01v-.871a.372.372 0 00-.364-.363H20.74a.372.372 0 00-.363.363v.895a2.56 2.56 0 00-2.082 2.785c.12 1.307 1.307 2.324 2.687 2.324h.654c.242 0 .46.097.63.29.169.17.242.412.217.654-.048.436-.436.75-.896.75h-.895a.542.542 0 01-.533-.435c-.024-.17-.194-.266-.339-.266h-1.017a.389.389 0 00-.266.12.364.364 0 00-.097.267 2.218 2.218 0 001.961 2.01v.871c0 .194.17.363.363.363h1.017c.194 0 .363-.17.363-.363v-.896c1.138-.242 1.986-1.162 2.083-2.251a2.636 2.636 0 00-.654-2.01z","fill":"#737791"}}),_c('path',{attrs:{"d":"M22.435 13.54l.581-1.526a.506.506 0 00-.46-.678h-7.094l-1.525 3.825-.314-2.687h.217a.243.243 0 00.242-.242v-.726a.243.243 0 00-.242-.243h-1.186a.243.243 0 00-.242.242v.727c0 .12.097.242.242.242h.218l-.315 2.687-1.5-3.752c-1.38.314-2.47 1.452-2.616 2.905l-.435 4.091a.757.757 0 00.63.848c.435.097 1.04.17 1.646.242l.387 6.513c.024.556.484.968 1.04.968h3.148c.557 0 .993-.436 1.041-.968l.533-11.161c0-.557.46-.993 1.017-.993h4.551a.49.49 0 00.436-.315zm-9.2-2.906a3.317 3.317 0 100-6.634 3.317 3.317 0 000 6.634z","fill":"#737791"}})])
          )
        }
      }
    